module.exports = __webpack_public_path__ + "static/media/6.0354b711.png";